// Нормализация ввода числа: запятая → точка, пустая строка → null (бэкенд ждёт null, не "").
export function normalizeNumberInput(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  return raw.replace(",", ".");
}

// Список непустых строк без дублей, с сохранением порядка.
export function uniqStrings(list) {
  const out = [];
  const seen = new Set();
  for (const v of Array.isArray(list) ? list : []) {
    const s = String(v || "").trim();
    if (!s) continue;
    if (seen.has(s)) continue;
    seen.add(s);
    out.push(s);
  }
  return out;
}
